<template>
    <div class="payment-result">
        <div class="container">
            <div class="status-box" v-if="status === 'PENDING'">
                <van-loading type="spinner" size="28" />
                <h2>正在确认支付结果</h2>
                <p class="muted">页面正在等待支付宝回跳并确认支付结果，请保持此页打开。</p>
            </div>

            <div class="status-box success" v-else-if="status == '1'">
                <van-icon name="success" size="64" />
                <h1>支付成功</h1>
                <p class="amount" v-if="orderAmount">¥ {{ orderAmount }}</p>
                <div class="meta-row">
                    <span class="meta-label">订单号：</span>
                    <span class="meta-val">{{ orderId }}</span>

                </div>
                <div class="meta-row">
                    <span class="meta-label">下单时间：</span>
                    <span class="meta-val">{{ orderTime }}</span>
                </div>
                <div class="meta-row">
                    <span class="meta-label">付款时间：</span>
                    <span class="meta-val" v-if="payTime">{{ payTime }}</span>
                </div>
                <p class="muted">订单已确认，页面将在 {{ redirectCountdown }} 秒后跳转到代充订单列表。</p>
            </div>

            <div class="status-box timeout" v-else-if="status === '3'">
                <van-icon name="warn" size="64" />
                <h1>订单已取消</h1>
                <p class="amount" v-if="orderAmount">¥ {{ orderAmount }}</p>
                <div class="meta-row">
                    <span class="meta-label">订单号：</span>
                    <span class="meta-val">{{ orderId }}</span>


                </div>
                <div class="meta-row">
                    <span class="meta-label">下单时间：</span>
                    <span class="meta-val">{{ orderTime }}</span>
                </div>
                <div class="meta-row">
                    <span class="meta-label">取消时间：</span>
                    <span class="meta-val" v-if="payTime">{{ payTime }}</span>
                </div>
                <p class="muted">您已取消支付，页面将在 {{ redirectCountdown }} 秒后返回游戏代充页面。</p>
            </div>

            <div class="status-box unknown" v-else>
                <h2>无法确认支付</h2>
                <p class="muted">未提供订单号或查询异常，请联系客服。</p>
            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
export default {
    name: 'PaymentResult',
    data() {
        return {
            orderId: null,
            payScene: null,
            status: 'PENDING',
            pollingTimer: null,
            attempts: 0,
            maxAttempts: 30,
            intervalMs: 2000,
            orderAmount: null,
            redirectCountdown: 5,
            redirectTimer: null,
            redirectTarget: null,
            orderTime: null,
            payTime: null
        }
    },
    created() {
        this.orderId = this.$route.query.orderId
        this.payScene = this.$route.query.payScene
        if (!this.orderId) {
            this.status = 'UNKNOWN'
            return
        }
        this.checkStatusOnce()
        this.startPolling()
    },
    beforeUnmount() {
        this.stopPolling()
        this.stopRedirectCountdown()
    },
    methods: {
        async checkStatusOnce() {
            try {
                const res = await request.get(`/front/pay/status/2/${this.payScene}/${this.orderId}`)
                if (res && res.code === 200 && res.data) {
                    const raw = res.data.status
                    // 如果接口返回订单金额或其他明细，则保存
                    if (res.data.orderAmount) {
                        this.orderAmount = res.data.orderAmount
                    }
                    // 解析下单时间，兼容多个常见字段名
                    if (res.data.orderTime) {
                        this.orderTime = res.data.orderTime
                    }
                    if (res.data.payTime) {
                        this.payTime = res.data.payTime
                    }
                    // 支持数字状态：1=成功, 3=取消；也兼容字符串状态
                    if (res.data.status == '1') {
                        this.onPaid()
                        return
                    }
                    if (res.data.status == '3') {
                        this.onCanceled()
                        return
                    }
                }
            } catch (error) {
                console.log("查询失败")
            }
        },
        startPolling() {
            this.stopPolling()
            this.attempts = 0
            this.pollingTimer = setInterval(async () => {
                this.attempts++
                await this.checkStatusOnce()
                if (this.status === '1' || this.status === '3') {
                    this.stopPolling()
                    return
                }
                if (this.attempts >= this.maxAttempts) {
                    this.status = 'TIMEOUT'
                    this.stopPolling()
                }
            }, this.intervalMs)
        },
        stopPolling() {
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
                this.pollingTimer = null
            }
        },
        onPaid() {
            localStorage.removeItem("cartItems");
            this.status = '1'
            this.stopPolling()
            if (this.payScene == 11) {
                this.redirectTarget = '/proxyPlayHistory'
            } else if (this.payScene == 3) {
                this.redirectTarget = '/shopHistory'
            } else if (this.payScene == 1) {
                this.redirectTarget = '/wallet'
            }
            this.startRedirectCountdown()
        },
        startRedirectCountdown() {
            this.stopRedirectCountdown()
            this.redirectCountdown = 5
            this.redirectTimer = setInterval(() => {
                this.redirectCountdown--
                if (this.redirectCountdown <= 0) {
                    this.stopRedirectCountdown()
                    this.$router.push(this.redirectTarget)
                }
            }, 1000)
        },
        stopRedirectCountdown() {
            if (this.redirectTimer) {
                clearInterval(this.redirectTimer)
                this.redirectTimer = null
            }
        },

        onCanceled() {
            this.status = '3'
            this.stopPolling()
            if (this.payScene == 11) {
                this.redirectTarget = '/proxyPlay'
            } else if (this.payScene == 3) {
                this.redirectTarget = '/market'
            } else if (this.payScene == 1) {
                this.redirectTarget = '/wallet'
            }
            this.startRedirectCountdown()
        },
    }
}
</script>

<style scoped>
.payment-result {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 20px;
}

.container {
    text-align: center;
    max-width: 520px;
    width: 100%;
}

.status-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.status-box h2 {
    margin: 0;
}

.status-box h3 {
    margin: 0;
}

.muted {
    color: #999;
    font-size: 13px;
}

.meta-row {
    display: grid;
    /* 左侧标签占剩余空间，右侧内容自适应宽度并靠右 */
    grid-template-columns: 1fr auto;
    column-gap: 12px;
    align-items: center;
    margin-top: 8px;
    width: 100%;
    white-space: nowrap; /* 保证单行显示 */
}

.meta-label {
    color: #666;
    font-size: 13px;
    text-align: left;
    font-weight: 600;
    white-space: nowrap;
    padding-right: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.meta-val {
    color: #333;
    font-weight: 600;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.amount {
    font-size: 32px;
    color: #ee0a24;
    font-weight: 800;
    margin: 8px 0;
    width: 100%;
    text-align: center; /* 金额居中显示 */
    line-height: 1.1;
}

.actions {
    display: flex;
    gap: 8px;
    margin-top: 8px;
}

.success h2 {
    color: #07c160;
}

.fail h2 {
    color: #ee0a24;
}

.timeout h2 {
    color: #f90;
}

/* Responsive: narrow screens stack label above value */
/* 保持单行显示，极窄屏仍会省略内容，如果需要可在未来改为换行 */
</style>
